import { render, staticRenderFns } from "./UserAdminLocked.vue?vue&type=template&id=38ba7d98&"
import script from "./UserAdminLocked.js?vue&type=script&lang=js&"
export * from "./UserAdminLocked.js?vue&type=script&lang=js&"
import style0 from "./UserAdminLocked.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports